import { showLovableToast } from "../../components/common/LovableToast/showLovableToast";

/** Lovable-style toast — positioned above Zendesk on copy link. */
export const showPostDetailToast = (message = "Link copied") => {
  showLovableToast(message);
};
